<!--eslint-disable no-use-before-define -->
<template>
	<div>
        <tbody>
			<template>
				<div class="Rectangle-12-Copy-2" v-for="row in rows"
					:key="row.id">
                    <slot name="rows" :row="row"></slot>
				</div>
			</template>
		</tbody>
	</div>
</template>
<script>
export default {
	name: 'app-table-disenar-escala-data',
	props: {
		// puesto: String,
		rows: {
			type: Array,
			required: true,
		},
	},
};
</script>
<style lang="scss" scoped>
    .Rectangle-12-Copy-2 {
        width: 100%;
        max-width: 1032px;
        height: 44px;
        padding: 8px 0px 10px 35px;
        border-radius: 9px;
        border: solid 1px #e9e9e9;
        background-color: #fff;
        margin: 0 auto 3px;
        display: flex;
    }
    tbody {
        margin: 0 auto;
        display: block;
    }
    .Puesto-elemento {
        text-align: left;
        width: 18%;
    }
    .Cant-elemento {
        width: 12%;
    }
    .Promedio-elemento {
        width: 16.5%;
    }
    .Redondear-elemento {
       width: 11.5%;
    }
    .Sueldo-elemento {
        width: 14.5%;
    }
    .SueldoTotal-elemento {
        width: 15.5%
    }
    .SueldoIdeal-elemento {
        width: 12%;
    }
    span {
        text-align: center;
        height: 26px;
        font-family: NeuzeitGroT;
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.29;
        letter-spacing: normal;
        text-align: center;
        color: #545a54;
    }
</style>


// WEBPACK FOOTER //
// src/components/shared/table-disenar-escala/app-table-disenar-escala-data.vue